module.exports = __webpack_public_path__ + "img/law1-high.3aecdf14.png";